// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"6e26143b5e5400dd","5285":"335c3f0f47e952c9"}[chunkId] + ".css";
};